<template>
  <div class="search-result">
    <div class="search-result-header">
      <h4 class="search-result-title">
        <a class="" :href="prog.url">{{ prog.name }}</a>
        <small v-if="prog.partTimeQual == 'yes' && prog.fullTimeQual == 'no'">
          (Part time)</small
        >
        <small v-if="prog.partTimeQual === 'no' && prog.fullTimeQual == 'yes'">
          (Full time)</small
        >
        <small v-if="prog.partTimeQual == 'yes' && prog.fullTimeQual == 'yes'">
          (Part time/Full time)</small
        >
      </h4>
      <h5 class="search-result-subtitle">{{ prog.code }}</h5>
    </div>
    <div class="search-result-body">
      <p class="">{{ prog.description }}</p>
    </div>

    <div class="search-result-footer">
      <div class="search-result-footer-item" v-if="prog.trimester">
        <h5 class="meta-label">
          <i aria-hidden="true" class="icon-clock"></i>
          <span class="meta-labelText">Duration</span>
        </h5>
        <p class="">{{ prog.trimester }} trimesters</p>
      </div>

      <div class="search-result-footer-item" v-if="prog.points">
        <h5 class="meta-label">
          <i aria-hidden="true" class="icon-graduation-cap"> </i>
          <span class="meta-labelText">Points</span>
        </h5>
        <p class="">{{ prog.points }}</p>
      </div>

      <div class="search-result-footer-item" v-if="prog.qualType">
        <h5>
          <i class="icon-book"></i>
          <span class="meta-labelText">Study type</span>
        </h5>
        <p class="">{{ capitalize(prog.qualType) }}</p>
      </div>

      <!-- Fix this if needed.. was using wrong date 
      
      ***DONE-->
      <!-- <div class="search-result-footer-item">
        <h5>
          <i class="icon-calendar"></i>
          <span class="meta-labelText">Apply by date</span>
        </h5>
        <p class="">{{ applyDate }}</p>
      </div> -->

      <div class="search-result-footer-item">
        <h5>
          <i class="icon-calendar"></i>
          <span class="meta-labelText">Next start date</span>
        </h5>
        <p class="">{{ startDate }}</p>
      </div>

      <!-- 
        <div class="search-result-footer-item">
               <h5 class="meta-label"><i aria-hidden="true" class="icon-money"></i> <span class="meta-labelText">Estimated fees</span></h5>
              <p class="" v-if="prog.internationalFeeTotal">

                  {{prog.internationalFeeTotal | currency('NZ$', 0) }}  {{prog.internationalFeeTerm}} 

              </p>
              <p class="" v-else>
                Not currently available
              </p>
        </div> -->

      <!-- <div class="search-result-footer-item">
               <h5 class="meta-label"><i aria-hidden="true" class="icon-money"></i> <span class="meta-labelText">Estimated fees</span></h5>
              <p class="" v-if="prog.feeTuition">

                  {{prog.feeTuition | currency('$', 0) }}  {{prog.feePeriod}} 

              </p>
              <p class="" v-else>
                Not currently available
              </p>
        </div> -->

      <!-- <div class="search-result-footer-item">
          <h5><i class="icon-calendar"></i>Year</h5>
          <p class="">2020</p>
        </div> -->
    </div>
  </div>
</template>

<script>
import Vue2Filters from "vue2-filters";
import moment from "moment";

export default {
  name: "pgprogramme",
  props: ["prog", "index"],
  computed: {
    startDate() {
      // if (this.prog.keyDateSet.custom) {
      //   return this.prog.keyDateSet.custom.content;
      // } else {

      // }

      if (this.prog.keyDateSet) {
        let flexDates = false;

        let dates = this.prog.keyDateSet.filter( dates => dates.domestic == true)
        .map((dateSet) => {
          if (dateSet.custom) {
            flexDates = true;
            return dateSet.custom.content;
          }

          return dateSet.startDate;
        });

        if (flexDates) {
          return dates[0];
        }

        //removes null objects
        let startDates = dates
          .filter(Boolean)
          .map((d) => {
            return moment(d.date).format("YYYYMMDD");
          })
          .sort((a, b) => a - b);

        //get next date
        const today = moment().format("YYYYMMDD");
        const nextDate = startDates.find((d) => d > today);

        return nextDate > today
          ? moment(nextDate).format("DD MMM YYYY")
          : "To be advised";
      } else {
        return "To be advised";
      }
    },
     applyDate () {
        // if (this.prog.keyDateSet.custom) {
        //   return this.prog.keyDateSet.custom.content;
        // } else {

        // }
        
        if (this.prog.keyDateSet) {

          let flexDates = false;

          let dates = this.prog.keyDateSet.filter( dates => dates.domestic == true).map(dateSet => {

            if (dateSet.custom && !dateSet.applyDate) {
              flexDates = true;
              return dateSet.custom.content;
            }

            return dateSet.applyDate
          });

          if(flexDates) {
            return dates[0];
          }
  
          //removes null objects
          let applyDates = dates.filter(Boolean).map( d => {
            return moment(d.date).format('YYYYMMDD')
          }).sort((a,b) => a - b)
  
          //get next date
          const today = moment().format('YYYYMMDD');
          const nextDate = applyDates.find(d => d > today )
          
          return nextDate > today ? moment(nextDate).format('DD MMM YYYY'): 'To be advised';
        } else {
          return 'To be advised';
        }

      }
  },
  methods: {
    capitalize(s) {
      return s ? s[0].toUpperCase() + s.slice(1) : "";
    },
  },
};
</script>

<style lang="scss" scoped>
.search-result .search-result-footer .search-result-footer-item {
  flex: 1 1 calc(20% - 2rem);

    @media (max-width: 42.99em) {
     flex: 0 0 calc(33% - 2rem);
  }
}
</style>